import { digitsFromStr } from '../util/strings';

export const formatZipCode = (input: string): string => {
    const parsed = digitsFromStr(input);
    // Only keep first 5 digits
    return parsed.slice(0, 5);
};
